import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import {
  makeHeadData,
  getDate,
  makeRowColumn,
  getHeadObj,
} from 'lib/commonLib';
import { lastDay, fluctuation } from 'modules/common';
import { monthStatistics, monthCompare, monthsub } from 'lib/api/time';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import BasicTable from 'components/molecules/MbBasicTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';
import SwitchingArea from 'components/organisms/SwitchingArea';

import StatisticsGraph from './StatisticsGraph';

/**
 * 테이블 나오는 순서
 */
const tableOrder = [
  { key: 'WEB_ADVRTS_AMT', label: '웹 지출금액' },
  { key: 'MOBILE_ADVRTS_AMT', label: '모바일 지출금액' },
  { key: 'B_ADVRTS_AMT', label: '배너 지출금액' },
  { key: 'S_ADVRTS_AMT', label: '브랜드커버 지출금액' },
  { key: 'I_ADVRTS_AMT', label: '아이커버 지출금액' },
  { key: 'M_ADVRTS_AMT', label: '문맥 지출금액' },
  { key: 'T_ADVRTS_AMT', label: '네이티브 지출금액' },
  { key: 'P_ADVRTS_AMT', label: '플레이링크 지출금액' },
];

const tableInfoJson = {
  WEB_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  MOBILE_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  B_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  S_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  I_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  M_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'APP_CNT',
  },
  T_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
  P_ADVRTS_AMT: {
    headList: [
      {
        id: 'STATS_DTTM',
        label: '날짜',
        orderFlag: true,
        type: 'string',
        format: '@',
      },
      {
        id: 'ADVRTS_AMT',
        label: '지출금액',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'PREV_MONTH_COMPARE',
        label: '전월대비',
        orderFlag: true,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  },
};

let initialization = false;
let initParam = {
  sDate: getDate(moment(moment().subtract(13, 'month').format('YYYY-MM-01'))),
  eDate: moment().format('YYYYMMDD'),
};
const Statistics = () => {
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const dispatch = useDispatch();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({});

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
    getData();
    // eslint-disable-next-line
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customizedMonth = {
    WEB_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    MOBILE_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    B_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    S_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    I_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    M_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    T_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
    P_ADVRTS_AMT: {
      PREV_MONTH_COMPARE: {
        makeBody: (rowObj, headsMap) => {
          const target = getHeadObj(headsMap, 'PREV_MONTH_COMPARE');
          return (
            <>
              {fluctuation(
                rowObj['PREV_MONTH_COMPARE'],
                makeRowColumn(
                  rowObj['PREV_MONTH_COMPARE'],
                  target.type,
                  target.format
                )
              )}
            </>
          );
        },
      },
    },
  };

  const customized = {
    STATS_MTH: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'STATS_MTH').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const adverCnt = getHeadObj(headsMap, 'STATS_MTH');
        return (
          <>
            {makeRowColumn(rowObj['STATS_MTH'], adverCnt.type, adverCnt.format)}
          </>
        );
      },
    },
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'CLICK_CNT').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const clickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        const rowMonth = rowObj['STATS_MTH'];

        const showWindowUrl =
          '/report/adver/detail?sDate=' +
          rowMonth +
          '01&eDate=' +
          rowMonth +
          lastDay(rowMonth) +
          '&uri=/report/adver/detail&isPop=1&popGroup=adver';
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CLICK_CNT'],
              clickCnt.type,
              clickCnt.format
            )}
            icon={rowMonth !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 월의 광고주별 상세 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    },
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return <>지출금액(쇼핑지출금액)</>;
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            <span className={'black'}>
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                trgtAdvrtsAmt.type,
                trgtAdvrtsAmt.format
              )}
              )
            </span>
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'MOB_SESSION_ROAS').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'MOB_SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const trgtMobSessionRoas = getHeadObj(
          headsMap,
          'TRGT_MOB_SESSION_ROAS'
        );
        const mobSessionOrderAmt = getHeadObj(
          headsMap,
          'MOB_SESSION_ORDER_AMT'
        );
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              mobSessionRoas.type,
              mobSessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              trgtMobSessionRoas.type,
              trgtMobSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              mobSessionOrderAmt.type,
              mobSessionOrderAmt.format
            )}
          />
        );
      },
    },
    MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    TRGT_MOB_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
        const trgtSessionRoas = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['SESSION_ROAS'],
              sessionRoas.type,
              sessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              trgtSessionRoas.type,
              trgtSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              sessionOrderAmt.type,
              sessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ORDER_AMT: {
      merged: true,
    },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'DIRECT_ROAS').label +
                '(' +
                t('쇼핑') +
                ')'
              }
              tooltipType={'DIRECT_ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
        const trgtDirectRoas = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['DIRECT_ROAS'],
              directRoas.type,
              directRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              trgtDirectRoas.type,
              trgtDirectRoas.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              directOrderAmt.type,
              directOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: {
      merged: true,
    },
    DIRECT_ORDER_AMT: {
      merged: true,
    },
    ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ROAS').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ROAS');
        const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
        const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ROAS'],
              trgtRoas.type,
              trgtRoas.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              orderAmt.type,
              orderAmt.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: {
      merged: true,
    },
    ORDER_AMT: {
      merged: true,
    },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ECPM').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ECPM'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const ecpm = getHeadObj(headsMap, 'ECPM');
        const trgtEcpm = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ECPM'], ecpm.type, ecpm.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ECPM'],
              trgtEcpm.type,
              trgtEcpm.format
            )}
          />
        );
      },
    },
    TRGT_ECPM: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  const getData = () => {
    setLoading(true);

    monthCompare({
      params,
    })
      .then((response) => {
        const { data } = response.data;
        setList({
          WEB_ADVRTS_AMT: data.WEB_ADVRTS_AMT.data,
          MOBILE_ADVRTS_AMT: data.MOBILE_ADVRTS_AMT.data,
          B_ADVRTS_AMT: data.B_ADVRTS_AMT.data,
          S_ADVRTS_AMT: data.S_ADVRTS_AMT.data,
          I_ADVRTS_AMT: data.I_ADVRTS_AMT.data,
          M_ADVRTS_AMT: data.M_ADVRTS_AMT.data,
          T_ADVRTS_AMT: data.T_ADVRTS_AMT.data,
          P_ADVRTS_AMT: data.P_ADVRTS_AMT.data,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      adverId: data.ADVER_ID,
    };
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = {
      url: url,
      cnt: popIndex,
    };

    dispatch(setPortal(newPortal));
  };

  const childColumnSet = {
    ADVER_ID: () => {
      return null;
    },
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initData={initParam}
          initialization={initialization}
          getParam={getParam}
          noneExternalFilter
          productTargeting
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <StatisticsGraph params={{ ...params }} />
          <SwitchingArea
            noneReset={true}
            title={<>{t('월별 통계 전월대비 데이터')}</>}
          >
            <ContentsWrap contentsCount={4}>
              {(() => {
                const result = [];
                for (let i = 0; i < tableOrder.length; i++) {
                  const { key, label } = tableOrder[i];
                  const tableInfo = tableInfoJson[key];
                  result.push(
                    <div key={key}>
                      <h6>{label}</h6>
                      <BasicTable
                        sort={tableInfo.sort}
                        order={tableInfo.order}
                        list={list[key]}
                        headCells={makeHeadData(tableInfo.headList)}
                        loading={loading}
                        customized={customizedMonth[key]}
                      />
                    </div>
                  );
                }
                return result;
              })()}
            </ContentsWrap>
          </SwitchingArea>
          <TableContainer
            dataReqPromise={monthStatistics}
            dataDetailReqPromise={monthsub}
            params={{ ...params }}
            sort="desc"
            order="STATS_MTH"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
            noneSearch
            expandTable
            makeSubParam={makeSubParam}
            childColumnSet={childColumnSet}
          />
        </>
      )}
    </>
  );
};

export default Statistics;
